export function cx(...parts) {
    return parts.filter(Boolean).join(" ");
}
//# sourceMappingURL=cx.js.map